import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { DescriptionSharp as DescriptionIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import DialogButtonActions from '~/modules/common/components/DialogButtonActions';
import AddVendorForm from '../AddVendorForm';
import { useAddVendor } from '../../hooks/useAddVendor';

const saveVendorLabel = <FormattedMessage id="button.save" />;

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  }
}));

export const EditVendorBasicInfoDialog = ({ open, onClose, vendor }) => {
  const classes = useStyles();
  const isMobile = useIsBreakpointDown('sm');
  const refetchQueries = ['vendor'];
  const { validationSchema, onSubmit, initialState } = useAddVendor({
    onClose,
    vendor,
    refetchQueries
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialState}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle className={classes.dialogTitle} disableTypography>
          <DescriptionIcon className={classes.icon} />
          <Typography variant="h6">{vendor?.name}</Typography>
        </DialogTitle>
        <DialogContent>
          <AddVendorForm />
        </DialogContent>
        <DialogButtonActions
          onClose={onClose}
          primaryButtonMessage={saveVendorLabel}
        />
      </Dialog>
    </Formik>
  );
};

EditVendorBasicInfoDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  vendor: PropTypes.object.isRequired
};

export default EditVendorBasicInfoDialog;
